(function () {
	'use strict';

	angular.module('dcApp').service('AppSelectorService', AppSelectorService);

	AppSelectorService.$inject = [
		'$q',
		'$window',
		'$rootScope',
		'NgCore',
		'LoggerFactory',
		'ProjectStorage',
		'PROJECT_VAR_NAME',
		'PROJECT_LABEL_VAR_NAME',
		'STORAGE_SUFFIX',
		'JOBS_CACHE_STATUS',
		'CTX_VAR_NAME',
	];

	function AppSelectorService(
		$q,
		$window,
		$rootScope,
		NgCore,
		LoggerFactory,
		ProjectStorage,
		PROJECT_VAR_NAME,
		PROJECT_LABEL_VAR_NAME,
		STORAGE_SUFFIX,
		JOBS_CACHE_STATUS,
		CTX_VAR_NAME
	) {
		const logger = LoggerFactory.getLogger('AppSelectorService', false);
		let selectedProjectId = null;
		let selectedProjectLabel = null;
		let selectedCtx = null;
		let isJobsCacheActive = null;

		clearProjectSelection();

		this.setSelectedProject = setSelectedProject;
		this.setSelectedContext = setSelectedContext;
		this.setIsJobsCacheActive = setIsJobsCacheActive;
		this.clearProjectSelection = clearProjectSelection;
		this.getSelectedProjectId = getSelectedProjectId;
		this.getSelectedProjectLabel = getSelectedProjectLabel;
		this.getSelectedCtxId = getSelectedCtxId;
		this.getIsJobsCacheActive = getIsJobsCacheActive;

		function getSelectedProjectId() {
			if (!isEmpty(selectedProjectId)) {
				return selectedProjectId;
			}
			selectedProjectId = $window.localStorage.getItem(PROJECT_VAR_NAME);
			if (selectedProjectId === null) {
				logger.warn('attempting to use project id before selecting a project');
			}

			return selectedProjectId;
		}

		function getSelectedProjectLabel() {
			if (!isEmpty(selectedProjectLabel)) {
				return selectedProjectLabel;
			}
			selectedProjectLabel = $window.localStorage.getItem(
				PROJECT_LABEL_VAR_NAME
			);
			if (selectedProjectLabel === null) {
				logger.warn('attempting to use project id before selecting a project');
			}

			return selectedProjectLabel;
		}

		function getSelectedCtxId() {
			if (selectedCtx === null) {
				logger.warn('no context is available. Getting stored context');
				return ProjectStorage.getSelectedContext();
			}
			return selectedCtx;
		}

		function setSelectedContext(ctxId) {
			selectedCtx = ctxId;
			logger.warn('setting context:', selectedCtx);
			ProjectStorage.setCurrentContext(ctxId);
		}

		function getIsJobsCacheActive() {
			if (isJobsCacheActive === null) {
				logger.warn('no value set by user. Returning default value (True)');
				return true;
			}
			return isJobsCacheActive;
		}

		function setIsJobsCacheActive(isActive) {
			isJobsCacheActive = isActive;
			logger.warn('setting jobs active state:', isJobsCacheActive);
			ProjectStorage.setIsJobsCacheActive(isActive);
		}

		function setSelectedProject(projectId, projectLabel) {
			selectedProjectId = projectId;
			selectedProjectLabel = projectLabel;
			$rootScope.currentProjectId = projectId;

			ProjectStorage.setValue({
				projectId: parseInt(`${projectId}`, 10),
				projectLabel: projectLabel,
			});
			$rootScope.currentProject = projectLabel;
			$rootScope.currentProjectId = projectId;
			clearElementsListConf();
			$rootScope.$broadcast('update:project:selection');
			NgCore.setProject(parseInt(`${projectId}`, 10), projectLabel);
			return $q.resolve();
		}

		function clearProjectSelection() {
			$window.sessionStorage.removeItem(PROJECT_VAR_NAME);
			$window.sessionStorage.removeItem(PROJECT_LABEL_VAR_NAME);
			$window.sessionStorage.removeItem(CTX_VAR_NAME);
			$window.sessionStorage.removeItem(JOBS_CACHE_STATUS);
			$window.localStorage.removeItem(PROJECT_VAR_NAME);
			$window.localStorage.removeItem(PROJECT_LABEL_VAR_NAME);
			$window.localStorage.removeItem(CTX_VAR_NAME);
			$window.localStorage.removeItem(JOBS_CACHE_STATUS);
			clearElementsListConf();
		}

		/**
		 * Private functions
		 */

		function clearElementsListConf() {
			let filterKeys = _.filter(_.keys($window.localStorage), function (key) {
				return key.endsWith(STORAGE_SUFFIX);
			});
			_.each(filterKeys, function (key) {
				$window.localStorage.removeItem(key);
			});
		}
	}
})();
